import Constants from '../utils/Constants';
import ServiceBase from './ServiceBase';
import InventoryManageModel from '../model/InventoryManageModel';

const URL = Constants.ServiceAPI.inventoryUrl + 'manage/';

export default class InventoryManageService extends ServiceBase {

  getListing = () => {
    let url = this.getServiceUrl(URL);

    let packet = this.buildRequestPacket(Constants.Http.Method.GET);

    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      let records = [];
              
      json.map( (record) => {
        records.push(new InventoryManageModel( record ));
      });
      
      return records;
    });
  }

  /**
   * Get the stored PDF report for the Completion Record
   * @param {*} completionRecordId 
   * @returns 
   */
  getInventoryReport = (completionRecordId) => {
    let url = this.getServiceUrl(Constants.ServiceAPI.inventoryUrl + 'record/report.php', completionRecordId);

    let packet = this.buildRequestPacket(Constants.Http.Method.GET);

    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      return json;
    });
  }

  /**
   * Deletes the completion record and all its corresponding data
   * @param {*} completionRecordId 
   * @returns 
   */
  deleteCompletionRecord = (completionRecordId) => {
    let url = this.getServiceUrl(URL, completionRecordId);

    let packet = this.buildRequestPacket(Constants.Http.Method.DELETE);

    return fetch(url, packet).then(this.convertResponseToJson).then(json => {
      return json;
    });
  }

}    